
export const initQueries = (queries) => ({
    type:"QUERY_INIT",
    queries,
});